import PageHeader from "@/components/layout/PageHeader";
import ServicesGrid from "@/components/home/ServicesGrid";
import BankPartners from "@/components/home/BankPartners";
import WhyChooseUs from "@/components/home/WhyChooseUs";
import FaqSection from "@/components/home/FaqSection";

export default function Services() {
  return (
    <>
      <PageHeader
        eyebrow="FASTag Services"
        title="Issuance, activation, recharge and replacement."
        subtitle="Everything you need to keep your FASTag active — with in-person guidance from a real team."
        primary={{ to: "/order", label: "Order Now" }}
      />
      <ServicesGrid />
      <BankPartners />
      <WhyChooseUs />
      <FaqSection />
    </>
  );
}
